import { Routes, Route, Navigate } from "react-router-dom";
import { CharterType } from "__generated__/enums";

import Declarations from "./Declarations";
import DeclarationsList from "./DeclarationsList";
import GroupedDeclarations from "./grouped/GroupedDeclarations";
import SaleDeclarations from "./SaleDeclarations";

const index = () => {
	return (
		<Routes>
			<Route index element={<Navigate to="purchase" replace />} />
			<Route path='/purchase' element={<Declarations />} />
			<Route path='/purchase/list' element={<DeclarationsList charterType={CharterType.Purchase} />} />
			<Route path='/purchase/grouped' element={<GroupedDeclarations charterType={CharterType.Purchase} />} />
			<Route path='/sale' element={<SaleDeclarations />} />
			<Route path='/sale/list' element={<DeclarationsList charterType={CharterType.Sales} />} />
			<Route path='/sale/grouped' element={<GroupedDeclarations charterType={CharterType.Sales} />} />
		</Routes>
	);
};

export default index;
